<template>
  <div id="pallet-editor" class="unselectable" v-if="pallet != null">
    <pallet-top
      :selectedPallet="pallet"
      :divider="dividerTop"
      :layers="layers"
      :user="user"
      @hideProduct="hideProduct"
      @updated="$emit('updated')"
      @productSelected="showProductImage"
    ></pallet-top>

    <pallet-structure-manual
      v-if="pallet.owned"
      :pallet="pallet"
      @updated="$emit('updated')"
    />

    <div id="pallet-side-wrapper" class="pallet-side-wrapper">
      <pallet-side :pallet="pallet" :divider="dividerSide"></pallet-side>
    </div>
    <div class="pallet-comments-wrapper">
      <div class="products-comments" v-if="pallet.products.length > 0">
        <div
          class="product-comment"
          v-for="(product, index) in pallet.products"
          :key="index"
        >
          <span v-if="product.comment != null">{{ product.comment }}</span>
        </div>
      </div>
      <div class="pallet-comment">
        <v-textarea
          name="input-7-1"
          :label="$t('pallet_content.comment')"
          box
          height="70"
          v-model="pallet.comment"
          @input="isWritingComment = true"
        ></v-textarea>
      </div>
      <div class="pallet-printable" v-if="pallet.owned">
        <PalletPrintable :pallet="pallet" @updated="$emit('updated')"></PalletPrintable>
        <div class="select-layers">
          {{$t('pallet_editor.select_layers')}}
          <input v-model="showLayers" @input="selectLayers" type="checkbox">
        </div>
        <div class="layer1">
          {{ $t("pallet_content.layer_1") }}
          <input class="layer-input" v-model="layers.layer1" @input="rememberLayer($event, 'layer_1')" type="checkbox" />
        </div>
        <div class="layer2">
          {{ $t("pallet_content.layer_2") }}
          <input class="layer-input" v-model="layers.layer2" @input="rememberLayer($event, 'layer_2')" type="checkbox" />
        </div>
        <div class="layer3">
          {{ $t("pallet_content.layer_3") }}
          <input class="layer-input" v-model="layers.layer3" @input="rememberLayer($event, 'layer_3')" type="checkbox" />
        </div>
        <div class="layer4">
          {{ $t("pallet_content.layer_4") }}
          <input v-model="layers.layer4" @input="rememberLayer($event, 'layer_4')" type="checkbox" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PalletSide from "@/components/user/pallets/PalletSide.vue";
import PalletStructureManual from "@/components/palleting/PalletStructureManual.vue";
import PalletPrintable from "@/components/user/pallets/PalletPrintableSelector.vue";
import Helper from "@/models/Helper.js";
import PalletTop from "@/components/palleting/PalletTop.vue";
export default {
  name: "pallet-editor",
  props: ["pallet", "user"],
  data() {
    return {
      layers: {
        layer1: localStorage.getItem("layer_1") === "true",
        layer2: localStorage.getItem("layer_2") === "true",
        layer3: localStorage.getItem("layer_3") === "true",
        layer4: localStorage.getItem("layer_4") ? localStorage.getItem("layer_4") === "true" : 1
      },
      showLayers: false,
      isWritingComment: false,
      dividerTop: 6,
      dividerSide: 12
    };
  },
  watch: {
    "pallet.comment"() {
      clearTimeout(this.commentTimer);
      this.commentTimer = setTimeout(() => {
        this.isWritingComment = false;
      }, 500);
    },
    async isWritingComment(val) {
      if (!val) {
        if(this.user.type == 6) return;
        this.$store.commit('setLoading', true);
        await this.pallet.save();
        this.$store.commit('setLoading', false);
      }
    },
    pallet(val) {
      if (val != null) {
        this.getDividers();
      }
    },
    tab(val) {
      if (val != null) {
        this.getDividers();
      }
    },
    layers: {
      handler(val){
        this.showLayers = val.layer1 && val.layer2 && val.layer3;
      },
      deep: true
    }
  },
  created() {
    window.addEventListener("resize", this.getDividers);
    this.getDividers();
  },
  destroyed() {
    window.removeEventListener("resize", this.getDividers);
  },
  mounted(){
    this.showLayers = this.layers.layer1 && this.layers.layer2 && this.layers.layer3;
  },
  methods: {
    getDividers() {
      this.getDividerTop();
      this.getDividerSide();
    },
    async getDividerTop() {
      await Helper.timeout(20);
      const screen = document.getElementById("pallet-editting-window");
      const minimumDivider = !screen
        ? 6
        : this.pallet.width / (screen.offsetHeight - 450);
      const screenWidth = !screen ? 600 : screen.offsetWidth - 200;
      const divider = this.pallet.length / screenWidth;
      if (divider < minimumDivider) {
        this.dividerTop = minimumDivider;
        return;
      }
      this.dividerTop = divider;
    },
    async getDividerSide() {
      const wrapper = document.getElementById("pallet-side-wrapper");
      if (!wrapper) {
        this.dividerSide = 12;
        return;
      }
      const divider = this.pallet.getHeight() / (wrapper.offsetHeight - 20);
      if (divider < 12) {
        this.dividerSide = 12;
        return;
      }
      this.dividerSide = divider;
    },
    showProductImage(product) {
      this.$emit("productSelected", product);
    },
    hideProduct() {
      this.$emit("hideProduct");
    },

    /**
     * opens text input to update selected layer
     * @param layer
     */
    updateStructure(layer) {
      this.$refs.structureEditor.openDialog(this.pallet, layer);
    },

    /**
     * opens text input to update selected pallet dimension
     */
    updatePalletDimensions(dimension) {
      this.$refs.dimensionsEditor.openDialog(this.pallet, dimension);
    },

    /**
     * saves to memory wheter or not we should show layers
     * @param event
     * @param layer
     */
    rememberLayer(event, layer){
      localStorage.setItem(layer, event.target.checked);
    },

    /**
     * 
     * @param event
     */
    selectLayers(event){
      for(let i = 0; i < 3; i++){
        this.layers[`layer${i+1}`] = event.target.checked;
        this.rememberLayer(event, `layer_${i+1}`);
      }
    },

    async getShowLayers(){
      await Helper.timeout(10);
      return (this.layers.layer1 == true && this.layers.layer2 == true && this.layers.layer3 == true) ? true : false;
    }
  },
  components: {
    PalletTop,
    PalletSide,
    PalletStructureManual,
    PalletPrintable
  }
};
</script>

<style scoped>
.pallet-top-wrapper {
  position: relative;
  top: 50px;
  left: 20px;
  width: calc(100% - 100px);
}
.pallet-side-wrapper {
  position: absolute;
  bottom: 50px;
  left: 35px;
  width: calc(100% - 100px);
  height: 200px;
}
.structure-controls {
  position: absolute;
  right: 0;
  top: 50px;
}
.pallet-comments-wrapper {
  position: absolute;
  right: 10px;
  bottom: 0;
  width: 300px;
  height: 280px;
}
.pallet-comment {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100px;
}
.products-comments {
  position: absolute;
  border: 3px solid rgba(71, 66, 66, 0.966);
  width: 100%;
  bottom: 100px;
}
.pallet-printable {
  position: absolute;
  right: 0;
}
.layer1{
  color: red;
}
.layer2{
  color: green;
}
.layer3{
  color: blue;
}
</style>
